import { render, staticRenderFns } from "./DRouter.vue?vue&type=template&id=0a312934&"
import script from "./DRouter.vue?vue&type=script&lang=js&"
export * from "./DRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports